"use strict";
exports.__esModule = true;
exports.determineIfDeliveryAttempt = void 0;
function determineIfDeliveryAttempt(event) {
    return !!((event === null || event === void 0 ? void 0 : event.routeId) &&
        (event === null || event === void 0 ? void 0 : event.failureReason));
}
exports.determineIfDeliveryAttempt = determineIfDeliveryAttempt;
